module.exports = __webpack_public_path__ + "img/pitch-active.99ab374e.svg";